import React from 'react'
import RelatedProductsRightRail from './RelatedProductsRightRail'
import {
  MappedComponentProperties,
  MapTo,
} from '@adobe/aem-react-editable-components'
import { ProductInput } from '@src/types/graphql-types'

type RelatedProductsProps = MappedComponentProperties & {
  title: string
  products: ProductInput[]
  totalProductsDisplay: number
}
const RelatedProductsRightRailAdapter: React.FC<RelatedProductsProps> = ({
  title,
  products,
  totalProductsDisplay,
}) => (
  <RelatedProductsRightRail
    title={title}
    products={products}
    totalProductsDisplay={totalProductsDisplay}
  />
)

export default MapTo<RelatedProductsProps>(
  'cms-commons/components/content/relatedproductsrightrail'
)(RelatedProductsRightRailAdapter)
